import { render, staticRenderFns } from "./_6.vue?vue&type=template&id=3224dc4b&"
import script from "./_6.vue?vue&type=script&lang=js&"
export * from "./_6.vue?vue&type=script&lang=js&"
import style0 from "./_6.vue?vue&type=style&index=0&id=3224dc4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports